import { FC } from 'react'
import { IUserBase } from '@/types'
import { AvatarLabelGroup } from '@components-v2/molecules/AvatarLabelGroup'
import { getUserAvatar, sanitizeUrl } from '@/utils'
import Link from 'next/link'
import styles from './index.module.scss'

type Props = {
  href: string
  user: IUserBase
  supportingText?: string
}

export const UserAvatarLabelGroupLink: FC<Props> = ({ href, user, supportingText }) => {
  return (
    <Link href={sanitizeUrl(href)}>
      <a className={styles.container}>
        <AvatarLabelGroup src={getUserAvatar(user)} text={user?.name} supportingText={supportingText} />
      </a>
    </Link>
  )
}
